import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import '@/App.css';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import QuoteRequests from '@/pages/QuoteRequests';
import Quotes from '@/pages/Quotes';
import QuoteDetail from '@/pages/QuoteDetail';
import Invoices from '@/pages/Invoices';
import Clients from '@/pages/Clients';
import ClientDetail from '@/pages/ClientDetail';
import Statistics from '@/pages/Statistics';
import Settings from '@/pages/Settings';
import Admin from '@/pages/Admin';
import ClientForm from '@/pages/ClientForm';
import ClientFormChat from '@/pages/ClientFormChat';
import SignQuote from '@/pages/SignQuote';
import Stock from '@/pages/Stock';
import Compta from '@/pages/Compta';
import Layout from '@/components/Layout';

// Lazy load Subscription to avoid circular import issues
const Subscription = React.lazy(() => import('@/pages/Subscription'));

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Axios interceptor for auth
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Axios response interceptor for subscription check
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 402) {
      // Subscription required - redirect to subscription page
      const currentPath = window.location.pathname;
      if (currentPath !== '/subscription' && currentPath !== '/login') {
        window.location.href = '/subscription';
      }
    }
    return Promise.reject(error);
  }
);

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/client-form" element={<ClientForm />} />
        <Route path="/devis" element={<ClientFormChat />} />
        <Route path="/sign-quote/:token" element={<SignQuote />} />
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <Layout>
                <React.Suspense fallback={<div className="flex items-center justify-center h-96"><div className="w-10 h-10 border-4 border-primary/30 border-t-primary rounded-full animate-spin"></div></div>}>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/requests" element={<QuoteRequests />} />
                    <Route path="/quotes" element={<Quotes />} />
                    <Route path="/quotes/:quoteId" element={<QuoteDetail />} />
                    <Route path="/invoices" element={<Invoices />} />
                    <Route path="/clients" element={<Clients />} />
                    <Route path="/clients/:clientEmail" element={<ClientDetail />} />
                    <Route path="/statistics" element={<Statistics />} />
                    <Route path="/stock" element={<Stock />} />
                    <Route path="/compta" element={<Compta />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/subscription" element={<Subscription />} />
                  </Routes>
                </React.Suspense>
              </Layout>
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
export { API };